import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, getDocs } from "firebase/firestore";
const db = getFirestore(firebaseApp);

//const {contextData} = useDataContext();
    

export default async function getProductos(productofolio) {
    const productosDB =  [];
    //console.log(valor);
    const collectionRef = collection(db, "Productos".replace(/ /g, ""));
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      productosDB.push(doc.data());
    });
    return productosDB;
    

}


//"+productofolio+"
